export const ZModal = "modal";
export const ZFlyout = "flyout";
export const ZTooltip = "tooltip";
export const ZChartTooltip = "chartTooltip";
export const ZMinimizeSideNavButton = "minimizeSideNavButton";
export const ZToast = "toast";
const zIndexes = {
    chartTooltip: 40000,
    flyout: 10050,
    minimizeSideNavButton: 100,
    modal: 10075,
    toast: 10100,
    tooltip: 30000,
};
export const zIndex = (component = ZModal) => {
    // Increase the index for that kind of component
    zIndexes[component] += 1;
    return zIndexes[component];
};
